export default "__VITE_ASSET__1ca6c71a__"